/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./utils/index');
require('./common');

// Plugins
require('./plugins/algolia');

// React components
require('./components/buttons/ReadMore');
require('./components/buttons/star-rating');
require('./components/body/block/breed-search');
require('./components/body/block/puppy-breeds');
require('./components/body/block/featured-puppies');

require('./components/Slider');
require('./components/buttons/SeeLocation');

require('./components/body/block/blog/Categories');
require('./components/body/block/blog/Posts');
require('./components/body/block/puppy/PuppyForSale');

if (location.pathname === '/breeders-search') {
  require('./components/body/block/breeder-search');
} else {
  require('./components/body/block/search');
}

require('./components/body/block/ReadMore');
require('./components/body/puppy-card-slider');

require('./components/autocomplete');
require('./components/buttons/set-location');


require('./components/body/block/breeder-reviews');

// Mobile Navigation
require('./nav');
